import React from 'react';
import AppRoutes from './routes/AppRoutes';
import './styles/app.css';

const App = () => {
  return <AppRoutes />;
};

export default App;
